export default "__VITE_ASSET__30faadc7__"